export default function (str: String) {
  return !str ?
    '' :
    str.replace(/<\/?[^>]+>/g, '');
}



// WEBPACK FOOTER //
// ./~/virgo/src/utils/stripTags.js